
import { SearchFlightRecommendation } from '@/types/models'
import { computed, defineComponent, PropType } from 'vue'

import EasyDrop from '@/components/EasyDrop.vue';

import { format } from "date-fns";
import * as Locales from 'date-fns/locale';
import intervalToDuration from 'date-fns/intervalToDuration';
import { LocaleStrings } from '@/types/paramModels';

export default defineComponent({
    name: "FlightItineraryModal",
    emits: ['closeModal'],
    components: {
        EasyDrop
    },
    props: {
        flight: {
            type: Object as PropType<SearchFlightRecommendation>,
            required: true
        },
        isShowModal: {
            type: Boolean
        },
        pageTexts: {
            type: Object,
            required: true
        },
        localeStrings: {
            type: Object as PropType<LocaleStrings>,
            required: true
        }
    },
    setup(_props, { emit }) {
        const showModal = computed(() => _props.isShowModal);

        const formatTotalTravelTime = (dateString: Date | string) => {
            return format(new Date(dateString), "k' " + _props.pageTexts['hotelPageFlightStepModalItineraryHour'] + " 'mm '" + _props.pageTexts['hotelPageFlightStepModalItineraryMinute'], { locale: Locales[_props.localeStrings.name] });
        };

        const formatDepartureTime = (dateString: Date | string) => {
            return format(new Date(dateString), "k':'mm", { locale: Locales[_props.localeStrings.name] });
        };

        const formatLongDate = (dateString: Date | string) => {
            return format(new Date(dateString), "do LLLL yyyy", { locale: Locales[_props.localeStrings.name] });
        };

        const formatTime = (dateString: string) => {
            return dateString.slice(dateString.indexOf("T") + 1, dateString.indexOf("T") + 6);
        }

        const formatDate = (dateString: string) => {
            return format(new Date(dateString.slice(0, dateString.indexOf("T"))), "do LLLL", { locale: Locales[_props.localeStrings.name] });
        }

        const formatDifferenceTime = (dateString1: Date | string, dateString2: Date | string) => {
            const duration = intervalToDuration({
                start: new Date(dateString1),
                end: new Date(dateString2)
            });
            if (duration && duration.days && duration.days > 0) {
                return duration.days + " " + _props.pageTexts['searchbarDateLabelDays'] + ", " + duration.hours + " " + _props.pageTexts['hotelPageFlightStepModalItineraryHour'] + " " + duration.minutes + " " + _props.pageTexts['hotelPageFlightStepModalItineraryMinute'];
            }
            return duration.hours + " " + _props.pageTexts['hotelPageFlightStepModalItineraryHour'] + " " + duration.minutes + " " + _props.pageTexts['hotelPageFlightStepModalItineraryMinute'];
        }

        const closeModal = () => {
            emit('closeModal');
        }

        const fixBody = () => {
            document.body.classList.add("modal-active");
        }

        const unfixBody = () => {
            document.body.classList.remove("modal-active");
        }

        return {
            showModal,
            formatTotalTravelTime,
            formatDepartureTime,
            formatLongDate,
            formatTime,
            formatDate,
            formatDifferenceTime,
            closeModal,
            fixBody,
            unfixBody
        }
    },
})
